exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification-stack.component {\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    padding: 3px;\n    z-index: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/notification/stack.css
// module id = 768
// module chunks = 0